import { useNavigate } from "react-router-dom";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Button,
  IconButton,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { useEffect, useState } from "react";

import SwitchToggle from "../../components/SwitchToggle";
import AddIcon from "@mui/icons-material/Add";
import {
  useDeleteDocMutation,
  useLazyGetDocQuery,
  useUpdateDocMutation,
} from "../../services/doc";
import { showError, showToast } from "../../constants/toasts";
import DeleteConfirmModal from "../../Modals/deleteConfirmModal";
import { isValidInput } from "../../utils/validations";
import IfCan from "../../components/IfCan";

const DocumentProcessing = () => {
  const navigate = useNavigate();

  const [getDoc, { isLoading }] = useLazyGetDocQuery();
  const [deleteDoc] = useDeleteDocMutation();
  const [UpdateStatus] = useUpdateDocMutation();
  const [Doc, setDoc] = useState<any[]>([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [length] = useState(10);
  const [selectedDoc, setSelectedDoc] = useState<any>(null);

  const fetchDocOcr = async () => {
    try {
      const response = await getDoc({
        length: 10,
        start: page,
        search: debouncedSearchTerm,
      }).unwrap();
      if (response?.status === 200 || response?.statusCode === 200) {
        setDoc(response.data || []);
      }
    } catch (error: any) {
      showError(error?.message || error?.data?.message);
    }
  };

  const handleDelete = async () => {
    if (!selectedDoc) return;

    try {
      const response = await deleteDoc({
        id: selectedDoc.id,
      }).unwrap();
      if (response?.status === 200 || response?.statusCode === 200) {
        showToast("Documnet  deleted successfully");
        setDeleteModalOpen(false);
        setSelectedDoc(null);
        fetchDocOcr();
      }
    } catch (error: any) {
      showError(error?.message || error?.data?.message);
    }
  };

  const handleStatusUpdate = async (id: number, status: boolean) => {
    const body = {
      is_active: status,
    };

    try {
      const response = await UpdateStatus({ body, id }).unwrap();
      if (response?.status === 200) {
        showToast(
          `Document  ${!status ? "deactivated" : "activated"} successfully`
        );
        fetchDocOcr();
      } else {
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };
  useEffect(() => {
    fetchDocOcr();
  }, [debouncedSearchTerm, page]);

  const columns = [
    { id: "tagSet", label: "Tag Set" },
    // { id: "summarization", label: "Summarization" },
    // { id: "summaryLog", label: "Processed Summary" },
    { id: "enabled", label: "Enable/Disable" },
    { id: "action", label: "Action" },
  ];

  const [searchTerm, setSearchTerm] = useState("");

  const openDeleteModal = (doc: any) => {
    setSelectedDoc(doc);
    setDeleteModalOpen(true);
  };

  return (
    <>
      <div className="main_title">
        <h1>Document Summarization & Feedback</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
          Document Processing
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                placeholder="Search..."
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
          </div>
          <IfCan module="Document Processing" action="add_edit">
            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() => navigate("/document-processing/add-document")}
              >
                <AddIcon /> Add{" "}
              </Button>
            </div>
          </IfCan>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow hover>
                {columns.map((col) => (
                  <TableCell key={col.id}>{col.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Doc.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No Data Found
                  </TableCell>
                </TableRow>
              ) : (
                Doc.map((row: any) => (
                  <TableRow hover key={row.id}>
                    <TableCell>{row.tag_set}</TableCell>
                    {/* <TableCell>{row.summarization}</TableCell> */}
                    {/* <TableCell>
                      <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
                        {row.processed_summary}
                      </pre>
                    </TableCell> */}

                    <TableCell>
                      <IfCan module="Document Processing" action="add_edit">
                        <SwitchToggle
                          defaultChecked={Boolean(row.is_active)}
                          onChange={(checked) =>
                            handleStatusUpdate(row?.id, checked)
                          }
                        />
                      </IfCan>
                    </TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        <IfCan module="Document Processing" action="add_edit">
                          <Box>
                            <IconButton
                              onClick={() =>
                                navigate(
                                  `/document-processing/edit-document/${row.id}`
                                )
                              }
                            >
                              <img
                                src="/static/images/edit2_icon.svg"
                                alt="Edit"
                              />
                            </IconButton>
                          </Box>
                        </IfCan>
                        <IfCan module="Document Processing" action="delete">
                          <Box>
                            <IconButton onClick={() => openDeleteModal(row)}>
                              <img
                                src="/static/images/trash2_icon.svg"
                                alt="Delete"
                              />
                            </IconButton>
                          </Box>
                        </IfCan>
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <IfCan module="Document Processing" action="delete">
        <DeleteConfirmModal
          open={deleteModalOpen}
          setOpen={setDeleteModalOpen}
          handleDelete={handleDelete}
          title="Delete Document"
          message={`Are you sure you want to delete this document?`}
        />
      </IfCan>
    </>
  );
};

export default DocumentProcessing;
